var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._b({directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pa-6 cursor-pointer d-flex card-font-size"},'v-card',_vm.$attrs,false),[_c('div',{staticClass:"ma-auto"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }